// Adapted from davinci-elections packages/shared/src/routes.ts @ 6e23f58
import type { z } from 'zod'
import { healthRoutes } from './api/health'
import { adminAuthRoutes } from './api/admin-auth'
import { placesRoutes } from './api/places'
import { providersRoutes } from './api/providers'
import { groupsRoutes } from './api/groups'
import { communicationsRoutes } from './api/communications'
import { registrationRoutes } from './api/registration'
import { attemptRoutes } from './api/attempts'
import { publicRoutes } from './api/public'
import { captureRoutes } from './api/capture'
import { memberRoutes } from './api/member'
import { adminRoutes } from './api/admin'
import { documentsAdminRoutes } from './api/documents-admin'
import { documentRoutes } from './api/documents'

/**
 * The route table: every JSON endpoint of the API. Later tasks append their route groups to the spread below
 * (never reorder or rewrite another task's entries).
 */
export const routes = {
  ...healthRoutes,
  ...adminAuthRoutes,
  ...placesRoutes,
  ...providersRoutes,
  ...groupsRoutes, // T4
  ...communicationsRoutes, // T4
  ...registrationRoutes, // T6
  ...attemptRoutes, // T11
  ...publicRoutes, // T18
  ...captureRoutes, // T12
  ...memberRoutes, // T16
  ...adminRoutes, // T17
  ...documentsAdminRoutes, // identity document Task 14
  ...documentRoutes, // identity document Task 19: the member's document step
} as const

export type Routes = typeof routes
export type RouteName = keyof Routes

/** Infer helpers: `RouteResponse<'health'>`, `RouteBody<N>` (input shape). */
export type RouteResponse<N extends RouteName> = z.infer<Routes[N]['response']>
export type RouteBody<N extends RouteName> = Routes[N]['body'] extends z.ZodType ? z.input<Routes[N]['body']> : never
export type RouteQuery<N extends RouteName> = Routes[N]['query'] extends z.ZodType ? z.input<Routes[N]['query']> : never
export type RouteParams<N extends RouteName> = Routes[N]['params'] extends z.ZodType
  ? z.input<Routes[N]['params']>
  : never

/** Fill `:param` placeholders, URL-encoding values. */
export function buildPath(path: string, params: Record<string, string | number> = {}): string {
  return path.replace(/:([A-Za-z0-9_]+)/g, (_, key: string) => {
    const v = params[key]
    if (v === undefined) throw new Error(`Missing path param "${key}" for ${path}`)
    return encodeURIComponent(String(v))
  })
}
